import { Container, dispatcher, ingenuity, SpineBase } from "@quest/base-core";
import { GameParserModel } from "../../Platform/GameParserModel";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { HoldAndRespinView } from "../View/HoldAndRespinView";
import { gameConstants } from "../../Constants/gameConstants";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class ReSpinCounterController {
  protected view: HoldAndRespinView;
  private reSpinCounterContainer: Container;
  private spinCountAnimContainer: Container;
  private backGlowAnim: SpineBase;
  private backBlastAnim: SpineBase;
  private currentSpinCount: number = 3;
  constructor(view: HoldAndRespinView) {
    this.view = view;
    this.subscribeEvents();
    this.initializeElements();
    this.backGlowAnim.setPause(false);
    this.playBackAnims();
  }



  private initializeElements(): void {
    this.reSpinCounterContainer = this.view.getContainerByID("spinCountContainer");
    this.spinCountAnimContainer = this.view.getContainerByID("spinCountNumberAnimContainer");
    this.backGlowAnim = this.view.getSpineById("spinCountGlow_3");
    this.backBlastAnim = this.view.getSpineById("backBlastSpine");
  }
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT, this.updateCounter, this);
    dispatcher.on(eventDispatchers.RESET_COUNTER_TO_MAX, this.resetToMax, this);
  }
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT, this.updateCounter, this);
    dispatcher.off(eventDispatchers.RESET_COUNTER_TO_MAX, this.resetToMax, this);
  }
  // reset counter to 3 again with its presentation
  protected resetToMax(): void {
    this.resetAnimation();
    (ingenuity.soundManager as any).playSound(SoundConstantGame.RESPIN_COUNT_3, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    this.currentSpinCount = (ingenuity.parserModel as GameParserModel).getFishingTimeSpinCounter();
    this.spinCountAnimContainer.y = gameConstants.GLOW_ANIM_Y[this.currentSpinCount - 1];
    this.spinCountAnimContainer.alpha = 1;
    this.playResetAnimation();
  }
  /** play reset animation , blast behind 3 and a flow */
  protected playResetAnimation(): void {
    const backGlow = this.view.getSpineById("spinCountGlow_3");
    backGlow.setPause(false);
    backGlow.onComplete.dispose();
    backGlow.visible = true;
    this.backBlastAnim.visible = true;
    backGlow.playAnim("blast_effect", false);
    this.backBlastAnim.playAnim("blast_effect_back_rays", false);
    backGlow.onComplete.addOnce(() => {
      this.backBlastAnim.visible = false;
      backGlow.playAnim("glow_effect", true);
    });
  }
  /**
   * function will update the respin counter
   */
  private updateCounter(): void {
    this.currentSpinCount--;
    this.resetAnimation();
    this.setAnimPosition();
  }


  // Updates the animation position based on spinCount
  private setAnimPosition(): void {
    if (this.currentSpinCount === 0) {
      this.spinCountAnimContainer.alpha = 0;
      return;
    }
    const backGlow = this.view.getSpineById("spinCountGlow_" + this.currentSpinCount)
    backGlow.onComplete.dispose();
    backGlow.visible = true;
    backGlow.setPause(false)
    backGlow.playAnim("glow_effect", true);
  }
  /**to play back idle glow behind 3 */
  private playBackAnims(): void {
    this.view.getSpineById("spinCountGlow_3").visible = true;
    this.view.getSpineById("spinCountGlow_3").setPause(false);
    this.view.getSpineById("spinCountGlow_3").playAnim("glow_effect", true);
  }
  /**to reset animations behind all counters */
  private resetAnimation(): void {
    for (let i = 1; i <= 3; i++) {
      this.view.getSpineById("spinCountGlow_" + i).visible = false
      this.view.getSpineById("spinCountGlow_" + i).setPause(true);
    };
  };
  /**
   * reset counter controller
   */
  public resetController(): void {
    this.reSpinCounterContainer.visible = false;
    this.resetAnimation();
    this.unSubscribeEvents();
  }
}
